<!-- CaseRefContainer -->
<template>
  <div class="caseref">
    <h2>참고판례</h2>
    <p>{{ caseNum }}</p>
    <button @click="$emit('summarize', caseNum)" class="ref-buttons">
      요약하기
    </button>
    <button @click="$emit('showref', caseNum)" class="ref-buttons">
      전문보기
    </button>
  </div>
</template>

<script>
export default {
  name: 'CaseRefContainer',
  props: ['caseNum'],
  methods: {},
};
</script>

<style>
.caseref {
  width: 28%;
  height: 80%;
  padding: 3px;
  border: 1px solid lightgray;
  margin-top: 5px;
  margin-right: 3%;
  border-radius: 5px;
  text-align: center;
}
.caseref :is(h2, p) {
  font-size: 0.8em;
}
.ref-buttons {
  display: inline;
  padding: 2px;
  margin: 2%;
  border-radius: 2px;
  background-color: lightgreen;
  font-size: 0.7em;
  color: black;
  border: none;
  cursor: pointer;
}
.ref-buttons:active {
  background-color: orange;
}
</style>
